import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../Contexts/AuthContext'
import logo from './icons/feelsLogo.png'
import useUserInfo from '../services/hooks/useUserInfo'
import emptyUserIcon from './icons/profileBtn.png'
import './Navbar.css'
import useAccessLevel from '../Pages/Organizations/hooks/useAccessLevel'
import OrgPermissionBadge from './GeneralComponents/OrgPermissionBadge/OrgPermissionBadge'
import {
  groupRoles,
  groupAdminRole,
  orgRoles,
  orgRolesAdmin,
} from '../constants/roles'
import { useLocation } from 'react-router-dom'
import useAdminAccess from '../services/hooks/useAdminAccess'

const IS_DEV = process.env.REACT_APP_IS_DEV === 'true'

export default function Nav() {
  const [toggleProfileDropdown, setToggleProfileDropdown] = useState(false)
  const [profileButtonRect, setProfileButtonRect] = useState()
  const { getCurrentUser, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { icon } = useUserInfo()
  const { isInternalAdmin, isOrganization } = useAccessLevel()
  const { isAdmin, isInternal } = useAdminAccess()

  useEffect(() => {
    setToggleProfileDropdown(false)

    const button = document.getElementsByClassName('profile-button')[0]
    if (button) {
      setProfileButtonRect(button.getBoundingClientRect())
    }
  }, [location])

  async function handleLogout() {
    setToggleProfileDropdown(false)
    try {
      await logout()
    } catch (error) {
      console.log(error)
    }
  }

  function getSidebarWidth() {
    const sidebar = document.getElementById('sidebar')
    return sidebar.getBoundingClientRect().width
  }

  const adminLinks = isAdmin => {
    if (!isAdmin) {
      return null
    }
    return (
      <>
        <Link
          to="/organization"
          className="logout-button"
          onClick={() => setToggleProfileDropdown(false)}
        >
          Feels Team
        </Link>
        <Link
          to="/organizations"
          className="logout-button"
          onClick={() => setToggleProfileDropdown(false)}
        >
          Organizations
        </Link>
      </>
    )
  }

  const internalLinks = isInternalAdmin => {
    if (!isInternalAdmin) {
      return null
    }
    return (
      <Link
        to="/organizations"
        className="logout-button"
        onClick={() => setToggleProfileDropdown(false)}
      >
        Organizations
      </Link>
    )
  }

  const groupLinks = isOrganization => {
    if (!isOrganization) {
      return null
    }

    const user = getCurrentUser()
    const organizations = user.organizations
    const groups = organizations
      .reduce(
        (acc, organization) => [
          ...acc,
          ...organization.organization_user.organization_groups,
        ],
        []
      )
      .filter(group => group.name !== 'Organization')

    if (!groups.length) {
      return null
    }
    if (groups.length > 2) {
      return (
        <Link
          to={`/organizations/my-s`}
          className="logout-button"
          onClick={() => setToggleProfileDropdown(false)}
        >
          My Teams
        </Link>
      )
    }

    const links = organizations.map((organization, itemOrg) =>
      organization.organization_user.organization_groups
        .filter(group => group.name !== 'Organization')
        .map(group => {
          const organizationRole =
            organizations[itemOrg].organization_user.organization_groups[0]
              ?.roles[0]?.role
          const role = group.roles[0].role
          const ableToSee = groupRoles.includes(role) || groupAdminRole === role
          const ableToClick = groupAdminRole === role
          const isOwner = orgRolesAdmin[0] === organizationRole // 'Organization Owner'

          if (!ableToSee) return null
          const commonProps = {
            key: group.f_id,
            className: `logout-button ${
              !ableToClick ? 'disabled-logout-button' : ''
            }`,
          }

          return ableToClick ? (
            <Link
              {...commonProps}
              to={`/organizations/${organization.f_id}/teams/${group.f_id}`}
              onClick={() => setToggleProfileDropdown(false)}
            >
              {group.name} <span>team</span>
            </Link>
          ) : !isOwner ? (
            <div {...commonProps}>
              {group.name} <span>team</span>
            </div>
          ) : null
        })
    )
    return links
  }
  const organizationLinks = isOrganization => {
    if (!isOrganization) {
      return null
    }

    const user = getCurrentUser()
    const organizations = user.organizations
    const links = organizations.map(organization => {
      const role =
        organization.organization_user.organization_groups[0].roles[0].role
      const ableToSee = orgRoles.includes(role)
      const ableToClick = orgRolesAdmin.includes(role)

      if (!ableToSee) return null

      const commonProps = {
        key: organization.f_id,
        className: `logout-button ${
          !ableToClick ? 'disabled-logout-button' : ''
        }`,
      }

      return ableToClick ? (
        <Link {...commonProps} to={`/organizations/${organization.f_id}`}>
          {organization.name}
        </Link>
      ) : (
        <div {...commonProps}>{organization.name}</div>
      )
    })
    return links
  }

  return (
    <div id="navbar">
      <img
        id="navbar-logo"
        src={logo}
        alt="logo"
        onClick={() => {
          navigate('/artists')
        }}
      />
      <div className="right-container">
        <OrgPermissionBadge />
        {IS_DEV ? (
          <img
            className="label-logo"
            src={require('./icons/dev_logo.png')}
            alt="label logo"
          />
        ) : (
          <span className="your-logo-here-text">
            {/* RIGHTS HOLDER&#39;S LOGO HERE */}
          </span>
        )}
        <img
          className="profile-button"
          src={icon || emptyUserIcon}
          onError={e => {
            e.currentTarget.onerror = null
            e.currentTarget.src = emptyUserIcon
          }}
          onClick={() => {
            setToggleProfileDropdown(!toggleProfileDropdown)
          }}
          alt="profile"
          referrerPolicy="no-referrer"
        />
        {toggleProfileDropdown && (
          <div
            className="profile-dropdown-bg-container"
            style={{
              top: 0 + 'px',
              // right: -profileButtonRect.left - 300 + 'px',
              left: -getSidebarWidth() + 'px',
              // bottom: 200 + 'px',
            }}
            onClick={e => {
              const dataView =
                document.getElementsByClassName('profile-dropdown')
              const dataViewRect = dataView[0].getBoundingClientRect()
              const contains =
                e.clientX >= dataViewRect.x &&
                e.clientX <= dataViewRect.x + dataViewRect.width &&
                e.clientY >= dataViewRect.y &&
                e.clientY <= dataViewRect.y + dataViewRect.height

              if (!contains) {
                setToggleProfileDropdown(false)
              }
            }}
          >
            <div
              className="profile-dropdown"
              style={{
                top:
                  profileButtonRect.top + profileButtonRect.height + 20 + 'px',
                right:
                  profileButtonRect.left - profileButtonRect.left + 20 + 'px',
              }}
            >
              <p style={{ margin: 10, color: 'white', textAlign: 'center' }}>
                {getCurrentUser()?.email ?? ''}
              </p>
              <div style={{ backgroundColor: 'white', height: 0.5 }} />
              {adminLinks(isAdmin)}
              {internalLinks(isInternal)}
              {organizationLinks(isOrganization)}
              {groupLinks(isOrganization)}
              <a
                className="logout-button"
                onClick={() => {
                  handleLogout()
                }}
              >
                Log Out
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
